import axios from "axios";
import { Message } from "element-ui";
import router from "../router";

// var globalHost = "http://10.48.80.231:5005";

var globalHost = "http://101.200.185.46:5005";

function getUserInfo() {
  let user_id = sessionStorage.getItem("user_id");
  if (!user_id) {
    router.push({
      path: "/login",
    });
    return;
  }
  return new Promise((resolve, reject) => {
    axios
      .get(globalHost + "/api/users/detail")
      .then((res) => {
        resolve(res.data.results);
      })
      .catch((err) => {
        Message.error(err.data.errmsg);
        reject;
      });
  });
}

export { getUserInfo, globalHost };
